<div [style.display]="selected ? 'block' : 'none'">
  <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
</div>
